import { Box } from '@truepill/react-capsule'

export function PV1PrescriberCardTitle() {
  return <Box>PRESCRIBER</Box>
}
